import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef, Input} from '@angular/core';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CustomFormComponent} from '../../classes/custom-form-component';

@Component({
    selector: 'price-input',
    templateUrl: './price-input.component.html',
    styleUrls: ['./price-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PriceInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PriceInputComponent),
            multi: true,
        },
    ],
})
export class PriceInputComponent extends CustomFormComponent<number> {
    @Input() autoComplete = false;
    @Input() currencySymbol = '$';
    @Input() allowEmpty = false;
    @Input() forceCents = true;

    private selectionStart;
    private selectionEnd;
    private _stringValue: string;

    get stringValue() {
        return this._stringValue;
    }

    set stringValue(value: string) {
        this._stringValue = value;
        this.invokeChangeCallback(this.allowEmpty && !this._stringValue ? null : Number(this._stringValue));
    }

    constructor($el: ElementRef, cd: ChangeDetectorRef) {
        super($el, cd);
    }

    numberToString(value: number): string {
        const str = value.toFixed(2);
        if (this.forceCents) {
            return str;
        }
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (str.substr(-3) === '.00') {
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            return str.slice(0, -3);
        }
        if (str[str.length - 1] === '0') {
            return str.slice(0, -1);
        }
        return str;
    }

    writeValue(value) {
        super.writeValue(value);
        if (value === 0) {
            return (this._stringValue = '0');
        }
        if (typeof value === 'number') {
            return (this._stringValue = this.numberToString(value));
        }
        this._stringValue = value ? String(value) : '';
    }

    onKeyPress(event: UIEvent) {
        const target = <HTMLInputElement>event.target;
        this.selectionStart = target.selectionStart;
        this.selectionEnd = target.selectionEnd;
    }

    updateInputValue(target, value) {
        target.value = value;
        target.selectionStart = this.selectionStart;
        target.selectionEnd = this.selectionEnd;
    }

    onInput(event: UIEvent) {
        const target = <HTMLInputElement>event.target;
        const originalValue = target.value;

        if (!originalValue) {
            this.stringValue = '';
            return this.updateInputValue(target, this.stringValue);
        }

        const stringValue = originalValue.split(',').join('.');
        let parts = stringValue.match(/^(\d*)(\.?)(\d{0,2})$/);
        if (!parts) {
            return this.updateInputValue(target, this.stringValue);
        }
        this.stringValue = parts[0];
    }

    onBlur() {
        this.invokeTouchCallback();
    }
}
